import React, { useState } from "react";
import { Button, Icon, Confirm } from "semantic-ui-react";
import { InstitutionApi } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { useTranslation } from "react-i18next";
import "./ClassItem.scss";

const institutionController = new InstitutionApi();

export function ClassItem(props) {
  const { institution, classNameValue, onReload } = props;
  const { accessToken } = useAuth();
  const { t } = useTranslation("teachers");
  const [showConfirm, setShowConfirm] = useState(false);

  const onOpenCloseConfirm = () => setShowConfirm((prev) => !prev);

  const openDeleteConfirm = () => {
    onOpenCloseConfirm();
  };

  const onDelete = async () => {
    try {
      // Aquí llamamos al método que elimina por índice
      await institutionController.deleteClassNumber(
        accessToken,
        institution._id,
        classNameValue,
      );
      console.log("Clase eliminada", classNameValue, institution._id);
      onReload();
      onOpenCloseConfirm();
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div className="class-item">
        <p>{classNameValue}</p>
        <Button icon color="red" onClick={openDeleteConfirm}>
          <Icon name="trash" />
        </Button>
      </div>

      <Confirm
        open={showConfirm}
        onCancel={onOpenCloseConfirm}
        onConfirm={onDelete}
        content={`${t("item.deleteClassConfirm")} "${classNameValue}"?`}
        size="mini"
      />
    </>
  );
}
